import type { ReactNode } from 'react'
import { Link } from 'react-router'
import { Stack, Text } from '@/design-system'
import { AppleGlyph, GoogleGlyph } from './BrandGlyphs'
import styles from '@/app/layouts/AuthLayout.module.css'

export function SocialRow() {
  return (
    <div className={styles.social}>
      <button type="button" className={styles.socialButton}>
        <AppleGlyph />
        Apple
      </button>
      <button type="button" className={styles.socialButton}>
        <GoogleGlyph />
        Google
      </button>
    </div>
  )
}

export function OrDivider() {
  return (
    <div className={styles.divider}>
      <span className={styles.line} />
      <Text variant="caption" tone="secondary">
        or
      </Text>
      <span className={styles.line} />
    </div>
  )
}

export function AuthFooter({
  question,
  actionLabel,
  to,
}: {
  readonly question: string
  readonly actionLabel: string
  readonly to: string
}) {
  return (
    <Stack className={styles.footer} align="center">
      <Text variant="caption" tone="secondary">
        {question}{' '}
        <Link to={to}>
          <Text as="span" variant="caption" weight="semibold" tone="primary">
            {actionLabel}
          </Text>
        </Link>
      </Text>
    </Stack>
  )
}

export function AuthHeading({ title, subtitle }: { readonly title: string; readonly subtitle: ReactNode }) {
  return (
    <Stack gap={2}>
      <Text as="h1" variant="title" weight="bold">
        {title}
      </Text>
      <Text variant="body" tone="secondary">
        {subtitle}
      </Text>
    </Stack>
  )
}
